export const ADD_USER_UPLOAD_IMAGE_TO_CANVAS = 'ADD_USER_UPLOAD_IMAGE_TO_CANVAS';
export const GET_USER_IMAGES_REQUESTED = 'GET_USER_IMAGES_REQUESTED';
export const GET_USER_IMAGES_FAILURE = 'GET_USER_IMAGES_FAILURE';
export const GET_USER_IMAGES_SUCCESS = 'GET_USER_IMAGES_SUCCESS';
export const ADD_USER_IMAGE_TO_SCRIBE = 'ADD_USER_IMAGE_TO_SCRIBE';
export const DELETE_USER_IMAGE_REQUESTED = 'DELETE_USER_IMAGE_REQUESTED';
export const DELETE_USER_IMAGE_FAILURE = 'DELETE_USER_IMAGE_FAILURE';
export const DELETE_USER_IMAGE_SUCCESS = 'DELETE_USER_IMAGE_SUCCESS';
export const GET_IMAGE_LIBRARIES = 'GET_IMAGE_LIBRARIES';
export const GET_IMAGE_LIBRARIES_SUCCESS = 'GET_IMAGE_LIBRARIES_SUCCESS';
export const GET_IMAGE_LIBRARIES_FAILURE = 'GET_IMAGE_LIBRARIES_FAILURE';
export const GET_IMAGE_LIBRARY = 'GET_IMAGE_LIBRARY';
export const GET_IMAGE_LIBRARY_SUCCESS = 'GET_IMAGE_LIBRARY_SUCCESS';
export const GET_IMAGE_LIBRARY_FAILURE = 'GET_IMAGE_LIBRARY_FAILURE';
export const SEARCH_IMAGE_SUCCESS = 'SEARCH_IMAGE_SUCCESS';
export const SEARCH_IMAGE = 'SEARCH_IMAGE';
export const SEARCH_IMAGE_FAILURE = 'SEARCH_IMAGE_FAILURE';
export const ADD_LIBRARY_IMAGE_TO_CANVAS = 'ADD_LIBRARY_IMAGE_TO_CANVAS';
export const UPLOAD_IMAGE_FILES = 'UPLOAD_IMAGE_FILES';

export const addUserImageToCanvas = (file, filename, scribeId, canvasSize, uploadMethod) => {
  return {
    type: ADD_USER_UPLOAD_IMAGE_TO_CANVAS,
    file,
    filename,
    scribeId,
    canvasSize,
    uploadMethod
  };
};

export const getUserImages = () => ({
  type: GET_USER_IMAGES_REQUESTED
});

export const getUserImagesFailure = error => ({
  type: GET_USER_IMAGES_FAILURE,
  error
});

export const getUserImagesSuccess = payload => ({
  type: GET_USER_IMAGES_SUCCESS,
  payload
});

export const addUserImageToScribe = (
  imageId,
  imageType,
  scribeId,
  provider = 'user',
  canvasSize,
  selectedLibrary,
  filename
) => ({
  type: ADD_USER_IMAGE_TO_SCRIBE,
  imageId,
  imageType,
  scribeId,
  provider,
  canvasSize,
  selectedLibrary,
  filename
});

export const addLibraryImageToCanvas = (
  imageId,
  imageType,
  scribeId,
  provider = 'library',
  canvasSize,
  selectedLibrary,
  filename
) => ({
  type: ADD_LIBRARY_IMAGE_TO_CANVAS,
  imageId,
  imageType,
  scribeId,
  provider,
  canvasSize,
  selectedLibrary,
  filename
});

export const deleteUserImage = imageId => ({
  type: DELETE_USER_IMAGE_REQUESTED,
  imageId
});

export const deleteUserImageFailure = error => ({
  type: DELETE_USER_IMAGE_FAILURE,
  error
});

export const getImageLibraries = () => ({
  type: GET_IMAGE_LIBRARIES
});

export const getImageLibrariesSuccess = libraries => ({
  type: GET_IMAGE_LIBRARIES_SUCCESS,
  libraries
});
export const getImageLibrariesFailure = error => ({
  type: GET_IMAGE_LIBRARIES_FAILURE,
  error
});

export const getImageLibrary = (libraryId, cursor) => ({
  type: GET_IMAGE_LIBRARY,
  libraryId,
  cursor
});

export const getImageLibrarySuccess = (libraryId, library, cursor) => ({
  type: GET_IMAGE_LIBRARY_SUCCESS,
  libraryId,
  library,
  cursor
});
export const getImageLibraryFailure = error => ({
  type: GET_IMAGE_LIBRARY_FAILURE,
  error
});

export const deleteUserImageSuccess = imageId => ({
  type: DELETE_USER_IMAGE_SUCCESS,
  imageId
});

export const searchImages = (query, offset) => ({
  type: SEARCH_IMAGE,
  query,
  offset
});

export const searchImagesSuccess = (results, totalImages) => ({
  type: SEARCH_IMAGE_SUCCESS,
  results,
  totalImages
});

export const searchImagesFailure = error => ({
  type: SEARCH_IMAGE_FAILURE,
  error
});

export const uploadImageFiles = ({ scribeId, files, uploadMethod }) => ({
  type: UPLOAD_IMAGE_FILES,
  scribeId,
  files,
  uploadMethod
});
